/* eslint-disable react/react-in-jsx-scope */
import { getAccessToken } from './jwt-token-access/accessToken';

const ConfigApp = props => {
    
    if(!window.sessionStorage.getItem("APP_ALL_CONFIGS"))
      buscarDadosConfig();

    // Função assíncrona para buscar dados da API
    async function buscarDadosConfig() {
        try {
        // Aguardar até que o valor esteja preenchido
        while ((getAccessToken()).length == 0) {            
            await new Promise(resolve => setTimeout(resolve, 1000)); // Esperar 100ms
        }
        // console.log('PASSOU');

        // Usar fetch nativo para contornar problema de CORS com axios
        const token = getAccessToken();
        const response = await fetch(`${process.env.REACT_APP_API_INT_LEADS}/api/configs`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        // Set storage        
        window.sessionStorage.setItem("APP_ALL_CONFIGS", JSON.stringify(data));

        // Set each key config
        data.forEach((cfg) => {
            window.sessionStorage.setItem(cfg.Chave, cfg.Valor);
          });        

        } catch (error) {
        console.error('🔍 Erro detalhado ao buscar configs:', error);
        
        // Tratamento específico de erros para configs
        if (error.code === 'ECONNREFUSED' || error.code === 'ENOTFOUND' || error.code === 'ECONNRESET') {
            console.error('❌ Servidor de configs não encontrado:', process.env.REACT_APP_API_INT_LEADS);
        } else if (error.code === 'ECONNABORTED') {
            console.error('❌ Timeout ao buscar configs. Servidor pode estar offline.');
        } else {
            console.error('❌ Erro desconhecido ao buscar configs:', error.message);
        }
        }
    }

    return <></>
}

export default ConfigApp;